import Vue from 'vue'
import router from '@/router/products' // 해당되는 router 폴더 지정
import Vuex from 'vuex'
import '@/utils/commonLoad'
import _ from 'lodash'
import store from './store'
import global from '@/common/global'
import Meta from 'vue-meta'
import i18n from './locales'
import { $utils } from '@/common/helper'

Vue.use(Vuex)
Vue.use(Meta)

/* inject i18n */
const lang = $utils.getCountryCode()
Vue.config.lang = lang

/* eslint-disable */
new Vue({
  el: '#app',
  i18n,
  router,
  store
})
